import { render, staticRenderFns } from "./AllowAccessAff.vue?vue&type=template&id=128157d5&scoped=true&"
import script from "./AllowAccessAff.vue?vue&type=script&lang=js&"
export * from "./AllowAccessAff.vue?vue&type=script&lang=js&"
import style0 from "./AllowAccessAff.vue?vue&type=style&index=0&id=128157d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128157d5",
  null
  
)

export default component.exports